export default __webpack_public_path__ + "static/media/logo--simple.8d9c5240.svg";